import { useRef, useEffect } from 'react'

/**
 * Syncs document scroll progress (0–1) into a ref readable inside R3F useFrame.
 * Uses window scroll so position:fixed canvas works correctly on mobile Safari.
 */
export function useScrollSync() {
  const scrollProgress = useRef(0)

  useEffect(() => {
    function onScroll() {
      const max = document.documentElement.scrollHeight - window.innerHeight
      scrollProgress.current = max > 0 ? window.scrollY / max : 0
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return scrollProgress
}
